import React from 'react';
import PropTypes from 'prop-types';

import { Stack, TextField, Typography } from '@metarouter-private/mr-mui';

const INPUT_PROPS = { 'data-test-id': 'disableNoteInput' };

export default function DisableRevisionModalContent({ disabledNote, onChange }) {
  const handleChange = event => onChange(event.target.value);

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        Share why this revision is being disabled. The note is saved in the Revision History tab, and the revision
        cannot be selected for deployment until it is enabled again.
      </Typography>
      <TextField
        label="Disable Note"
        value={disabledNote}
        onChange={handleChange}
        placeholder="e.g. Breaks checkout event mapping"
        fullWidth
        autoFocus
        multiline
        rows={3}
        inputProps={INPUT_PROPS}
      />
    </Stack>
  );
}

DisableRevisionModalContent.propTypes = {
  disabledNote: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
